import $$ from 'cmn-utils'

const baseUrl = "/api/report/";

export default {
    reportUnitMonth: {
        list: (params) => {
            return $$.get(baseUrl + 'report-unit-month/list', params)
        },
    }
}